"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shape = exports.nodeText = exports.EMPTY_MARKER = void 0;
exports.EMPTY_MARKER = '∅';
const NUM_RE = /^[$€£]?[\d.,]+%?$/;
const URL_RE = /^(?:https?:\/\/|www\.)\S+$/i;
const DATE_RE = /^(?:\d{4}-\d{2}-\d{2}|\d{1,2}[/-]\d{1,2}[/-]\d{2,4})$/;
const TIME_RE = /^\d{1,2}:\d{2}(?::\d{2})?\s*(?:[ap]m)?$/i;
const nodeText = (view) => {
    const cp = (view.calculatedProps ?? {});
    // An EMPTY string must fall through to the next source, so use || (NOT ??,
    // which would keep "").
    const t = view.contentDescription || cp.name || view.label || '';
    return String(t).trim();
};
exports.nodeText = nodeText;
/**
 * The Url/Date/Time buckets are checked ahead of the Num/Long/Short
 * fallthrough so a date or timestamp does not land in the generic "Short"
 * bucket alongside unrelated short labels, which would cost the shape
 * histogram its discriminative power.
 *
 * The Short/Long split at `shortMax` is an empirical threshold, not a semantic
 * one: a cheap proxy separating short information-bearing labels (a field name,
 * a button caption) from content-bearing prose. Short labels are listed
 * verbatim in a descriptor; long text is folded into the coarser bucket.
 */
const shape = (text, shortMax) => {
    if (!text) {
        return 'Empty';
    }
    if (URL_RE.test(text)) {
        return 'Url';
    }
    if (DATE_RE.test(text)) {
        return 'Date';
    }
    if (TIME_RE.test(text)) {
        return 'Time';
    }
    if (NUM_RE.test(text)) {
        return 'Num';
    }
    if (text.length > shortMax || text.includes('\n')) {
        return 'Long';
    }
    return 'Short';
};
exports.shape = shape;
//# sourceMappingURL=textNorm.js.map